import { APIResponse } from 'api';
import { EngagementHeatmapData } from 'models';
import { useQuery } from 'react-query';

export default function useEngagementHeatmap(engagementId: string) {
  const path = `/plugins/vdp/velocityengage/engagement/${engagementId}/heatmapData`;
  return useQuery<APIResponse<EngagementHeatmapData>>(path);
}
